import React from 'react';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import Colors from 'common/ui/Colors';

type Props = {
  onClick: () => void;
};

const RecentProtocolInstancesListFooter = ({ onClick }: Props) => {
  return (
    <Wrapper onClick={onClick}>
      <Typography variant="overline">+ View more runs</Typography>
    </Wrapper>
  );
};

const Wrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gridRow: 'auto',
  gridColumn: 'trailer / end',
  height: '48px',
  backgroundColor: Colors.GREY_20,
  cursor: 'pointer',
  '&:hover': {
    background: Colors.GREY_30,
  },
}));

export { RecentProtocolInstancesListFooter };
